import React from "react";
import { CircleBox, GambleAction, GambleCircle } from "./BoardStyled";
import { useCard } from "@orbital/games-frontend-library";
import { GAMBLE_PROPS } from "./interface";
import { handleCardColor } from "../../functions/cardHandlers";
import ScrollBarHost from "./ScrollBar";
export default function GambleBoard({ content, colors }: GAMBLE_PROPS) {
  const { handleCardSuit } = useCard();

  // todo add B and R to handlecardcolor in library
  return (
    <ScrollBarHost needScroll={content.length > 5}>
      {content.map((card: any, id: number) => (
        <CircleBox key={id} isWin={card.amount > 0}>
          <GambleCircle
            className="circle"
            background={handleCardColor(
              card.card,
              colors.secondaryText,
              colors.secondaryBackground
            )}
          >
            {handleCardSuit(card.card)}
            <GambleAction
              background={handleCardColor(
                card.type,
                colors.secondaryText,
                colors.secondaryBackground
              )}
            >
              {card.type !== "R" &&
                card.type !== "B" &&
                handleCardSuit(card.type)}
            </GambleAction>
          </GambleCircle>
          <h3>
            <p>{card.coeff}</p>
            <span>X</span>
          </h3>
        </CircleBox>
      ))}
    </ScrollBarHost>
  );
}
